import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";

import { Icon, IconName } from "../icon";
import { Badge } from "../badge";

import "./icon-button.css";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	isActive?: boolean;
	iconName?: IconName;
	title?: string;
	badgeText?: string;
	/** Add shadow as round button */
	elevated?: boolean;
	ref?: React.Ref<HTMLButtonElement>;
}

export const IconButton = ({
	iconName,
	type = "button",
	title,
	badgeText,
	isActive,
	className,
	elevated = false,
	children,
	ref,
	...props
}: IconButtonProps) => {
	const cssClass = classNames([
		"icon-button",
		{
			"icon-button--active": isActive,
			"icon-button--no-title": !title,
			"icon-button--elevated": elevated,
		},
		className,
	]);

	return (
		<button
			ref={ref}
			className={cssClass}
			// https://github.com/jsx-eslint/eslint-plugin-react/issues/1555
			type={type}
			{...props}
		>
			<div className="icon-button__icon-wrapper">
				<span className="icon-button__icon">
					<Icon iconName={iconName}>{children}</Icon>
					{badgeText ? (
						<Badge
							value={badgeText}
							disabled={props.disabled}
							className="icon-button__icon-badge"
						/>
					) : null}
				</span>
			</div>

			{title && <div className="icon-button__title">{title}</div>}
		</button>
	);
};

IconButton.displayName = "IconButton";
